(() => {
  'use strict';
  const drawer = document.getElementById('or-cart-drawer');
  if (!drawer || !drawer.showModal) return;
  const he = drawer.dataset.lang === 'he';
  const cartURL = drawer.dataset.cartUrl;
  const sectionID = drawer.dataset.sectionId;
  let busy = false, opener = null, previousOverflow = '', latestCart = null;
  const text = (a,b) => he ? a : b;
  const errorText = text('לא הצלחנו לעדכן את העגלה. נסו שוב.', 'We could not update your cart. Please try again.');
  function message(value, error = false) {
    document.querySelectorAll('[data-or-cart-message]').forEach(el => { el.textContent = value; el.hidden = !value; el.dataset.error = String(error); });
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-or-cart-content]').forEach(el => {
      el.setAttribute('aria-busy',String(value));
      el.querySelectorAll('button,input').forEach(control => control.disabled = value);
    });
  }
  async function json(url, options) {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    const body = await response.json();
    if (!response.ok || body.status >= 400) throw new Error(body.description || errorText);
    return body;
  }
  function codes(cart) {
    if (Array.isArray(cart.discount_codes)) return cart.discount_codes.filter(x => x.applicable).map(x=>x.code);
    const apps = [...(cart.cart_level_discount_applications || [])];
    (cart.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(x => apps.push(x.discount_application)));
    return [...new Set(apps.filter(x=>x.type==='discount_code').map(x=>x.title))];
  }
  async function refresh() {
    const url = new URL(cartURL, location.origin);
    url.searchParams.set('section_id', sectionID);
    url.searchParams.set('_cart_refresh', Date.now());
    const [cart, response] = await Promise.all([json(cartURL+'.js'),fetch(url,{credentials:'same-origin',cache:'no-store'})]);
    if (!response.ok) throw new Error(errorText);
    const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
    const content = parsed.querySelector('[data-or-cart-content]');
    if (!content) throw new Error(errorText);
    document.querySelectorAll('[data-or-cart-content]').forEach(el=>el.replaceWith(content.cloneNode(true)));
    document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
    document.querySelectorAll('[data-or-cart-heading-count]').forEach(el=>el.textContent=cart.item_count);
    latestCart = cart;
    setBusy(busy);
    return cart;
  }
  function close() { if (drawer.open) drawer.close(); }
  drawer.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    document.documentElement.classList.remove('or-cart-is-open');
    if (opener?.isConnected) opener.focus();
  });
  drawer.addEventListener('click',event => {
    if (event.target === drawer) {
      const r = drawer.getBoundingClientRect();
      if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) close();
    }
  });
  async function open(trigger) {
    if (!drawer.open) {
      opener = trigger || document.activeElement;
      previousOverflow = document.body.style.overflow;
      drawer.showModal();
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('or-cart-is-open');
      drawer.querySelector('[data-or-cart-close]').focus();
    }
    if (busy) return;
    setBusy(true); message('');
    try { await refresh(); } catch(error) { message(error.message || errorText,true); }
    finally { setBusy(false); }
  }
  async function mutate(endpoint,payload,after) {
    if (busy) return;
    setBusy(true);message('');
    try {
      const cart = await json(cartURL+'/'+endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      await refresh();
      if (after) await after(cart);
      else message(text('העגלה עודכנה','Cart updated'));
    } catch(error) { message(error.message || errorText,true); }
    finally { setBusy(false); }
  }
  document.addEventListener('click',event => {
    const closeButton = event.target.closest('[data-or-cart-close]');
    if (closeButton) { event.preventDefault();close();return; }
    const link = event.target.closest('a[href]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0 && link.target !== '_blank') {
      const url = new URL(link.href,location.origin);
      if (url.origin === location.origin && url.pathname.replace(/\/$/,'')===cartURL.replace(/\/$/,'')) {
        event.preventDefault();open(link);return;
      }
    }
    const quantity = event.target.closest('[data-or-quantity]');
    if (quantity) {
      const row = quantity.closest('[data-key]');
      const rows = [...quantity.closest('[data-or-cart-content]').querySelectorAll('[data-key]')];
      const index = rows.indexOf(row), root = quantity.closest('dialog') || quantity.closest('.or-cart-page');
      mutate('change',{id:row.dataset.key,quantity:Number(quantity.dataset.orQuantity)},()=>{
        message(text('הכמות עודכנה','Quantity updated'));
        const newRows = root.querySelectorAll('[data-key]');
        const target = newRows[Math.min(index,newRows.length-1)]?.querySelector('[data-or-quantity]');
        // Defer focus until controls have been re-enabled.
        requestAnimationFrame(()=>{(target || root.querySelector('[data-or-cart-close]') || root.querySelector('a'))?.focus();});
      });return;
    }
    const removeCode = event.target.closest('[data-or-remove-code]');
    if (removeCode) {
      const remaining = codes(latestCart || {}).filter(code=>code.toLowerCase()!==removeCode.dataset.orRemoveCode.toLowerCase());
      mutate('update',{discount:remaining.join(',')},()=>message(text('הקופון הוסר','Discount code removed')));
    }
  });
  document.addEventListener('submit',event=>{
    const form = event.target.closest('[data-or-coupon-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    const code = form.elements.discount.value.trim();
    if (!code) {message(text('הזינו קוד קופון','Enter a discount code'),true);form.elements.discount.focus();return;}
    const previous = codes(latestCart || {});
    const requested = [...new Set([...previous,code])];
    mutate('update',{discount:requested.join(',')},async cart=>{
      if (codes(cart).some(x=>x.toLowerCase()===code.toLowerCase())) {
        message(text('הקופון הוחל. הסכום עודכן.','Discount code applied. Your total has been updated.'));
      } else {
        // Preserve existing valid codes and discard the unsuccessful entry.
        await json(cartURL+'/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:previous.join(',')})});
        await refresh();
        message(text('הקוד אינו תקף לעגלה הזו, או שלא ניתן לשלב אותו עם ההנחות הקיימות.','This code is not valid for this cart, or cannot be combined with the current discounts.'),true);
      }
    });
  });
  document.addEventListener('orayta:cart-added',()=>open(document.activeElement));
  window.OraytaCart = {open,refresh};
  if (document.querySelector('.or-cart-page')) {
    setBusy(true);refresh().catch(()=>{}).finally(()=>setBusy(false));
  }
})();
